// @flow

import * as React from 'react';

type Props = {
  defaultValue?: any,
  render: (Function, any) => React.Node
};

export default ({ defaultValue = null, render }: Props) => {
  const { useState } = React;
  const [currentSection, setCurrentSection] = useState(defaultValue);

  const toggle = (index: any) => {
    setCurrentSection(index === currentSection ? null : index);
  };

  return render(toggle, currentSection);
};
